"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'btn:save': '保存',
  'btn:cancel': '取消',
  'btn:clear': '清除'
};
exports.default = _default;